import { useWeb3React } from 'hooks/web3';
import { useQuery } from 'react-query';
import { useConfig } from 'store/config';
import { useParams } from 'react-router-dom';
import { useRewardPrograms } from 'store/zustand/useRewardPrograms';
import { Crucible, CrucibleLock } from 'types';
import { Queries } from 'types/enum';
import { getLocksForSingleCrucible } from 'api/blockchain/crucibles';
import { getSingleCrucible } from 'api/blockchain/crucible';

export function useCrucible(crucibleAddress?: string) {
  const { crucibleId } = useParams<{ crucibleId: string }>();
  const web3React = useWeb3React();
  const config = useConfig(web3React.chainId || 1).config;

  return useQuery<Crucible | undefined, Error>(
    [Queries.SINGLE_CRUCIBLE, web3React.chainId, web3React.account, crucibleId],
    () =>
      getSingleCrucible(
        crucibleAddress || crucibleId,
        config.customMinterAddress,
        config.crucibleSubgraphUrl,
        config.transmuterAddress,
        config.mintingTokenAddress,
        config.crucibleFactoryAddress,
        config.crucibleFactoryCreationBlock,
        web3React.provider
      ),
    {
      enabled: !!web3React.provider && (!!crucibleAddress || !!crucibleId),
      retry: 1
    }
  );
}

export function useCrucibleLocks() {
  const web3React = useWeb3React();
  const { rewardPrograms, currentRewardProgram } = useRewardPrograms();
  const { crucibleId } = useParams<{ crucibleId: string }>();
  const { data: crucible, dataUpdatedAt: crucibleDateUpdatedAt } =
    useCrucible();

  return useQuery<CrucibleLock[], Error>(
    [
      Queries.SINGLE_CRUCIBLE_LOCKS,
      crucibleId,
      web3React.chainId,
      web3React.account,
      crucibleDateUpdatedAt
    ],
    () =>
      getLocksForSingleCrucible(
        web3React.chainId || 1,
        web3React.provider,
        rewardPrograms,
        currentRewardProgram,
        crucibleId!
      ),
    {
      enabled: !!crucible && !!rewardPrograms
    }
  );
}
